import type { RouteRecordRaw } from 'vue-router';

export const SALES_ORDER_ROUTER: RouteRecordRaw[] = [
  {
    path: '/sales-order',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/sales-order/list',
    children: [
      {
        path: 'list-b2b',
        component: () => import('@/modules/sales/salesOrder/views/SalesB2BList.vue'),
        name: 'B2B salesOrder List',
        meta: {
          title: 'B2B 주문 목록',
        },
      },
      {
        path: 'list-b2c',
        component: () => import('@/modules/sales/salesOrder/views/SalesB2CList.vue'),
        name: 'B2C salesOrder List',
        meta: {
          title: 'B2C 주문 목록',
        },
      },
      {
        path: 'create-b2b',
        component: () => import('@/modules/sales/salesOrder/views/SalesB2BCreate.vue'),
        name: 'B2B salesOrder Create',
        meta: {
          title: 'B2B 주문 등록',
        },
      },
      {
        path: 'create-b2c',
        component: () => import('@/modules/sales/salesOrder/views/SalesB2CCreate.vue'),
        name: 'B2C salesOrder Create',
        meta: {
          title: 'B2C 주문 등록',
        },
      },
    ],
  },
];
